import { render, staticRenderFns } from "./role_user.vue?vue&type=template&id=5be097a1"
import script from "./role_user.vue?vue&type=script&lang=js"
export * from "./role_user.vue?vue&type=script&lang=js"
import style0 from "./role_user.vue?vue&type=style&index=0&id=5be097a1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports